<!-- eslint-disable vue/valid-template-root -->
<template />
<script>
import sessionRedirect from './mixins'
export default {
  components: {
  },
  mixins: [sessionRedirect],
  data() {
    return {
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
</style>
